import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from 'components/common/ProtectedRoute';
import DefaultView from 'components/common/DefaultView';
import ProtectedProjectRoute from 'components/common/ProtectedProjectRoute';
import ProtectedDataRepoRoute from 'components/common/ProtectedDataRepoRoute';
import LandingPage from 'components/views/main/landing/LandingPage';

const Main = lazy(() => import('components/views/main/Main'));
const Login = lazy(() => import('components/views/login/Login'));
const ProjectRepository = lazy(() =>
  import('components/views/main/projects/ProjectRepository')
);
const DataRepository = lazy(() =>
  import('components/views/main/data/DataRepositoryMain/DataRepository')
);
const PowerBi = lazy(() => import('components/views/main/data/PowerBi/PowerBi'));
export const ROUTE_PATHS = {
  DEFAULT: '/',
  LOGIN: '/login',
  // LOGIN: '/',
  HOME: '/digitaltwin',
  PROJECT: '/projectRepository',
  DATA: '/dataRepository',
  POWERBI: '/powerbi',
};

const routes = [
  {
    path: ROUTE_PATHS.DEFAULT,
    element: <LandingPage />,
  },
  {
    path: ROUTE_PATHS.HOME,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <Main />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.PROJECT,
    element: (
      <ProtectedRoute>
        <ProtectedProjectRoute>
          <DefaultView>
            <ProjectRepository />
          </DefaultView>
        </ProtectedProjectRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.DATA,
    element: (
      <ProtectedRoute>
        <ProtectedDataRepoRoute>
          <DefaultView>
            <DataRepository />
          </DefaultView>
        </ProtectedDataRepoRoute>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.POWERBI,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <PowerBi />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  { path: ROUTE_PATHS.LOGIN, element: <Login /> },
  {
    path: '*',
    element: <Navigate to={ROUTE_PATHS.DEFAULT} />,
  },
];

export default routes;
